/* eslint-disable no-magic-numbers */
import React from 'react';
import PropTypes from 'prop-types';
import css from '../cards/SellerCard.APP_TARGET.scss';
import Icon from 'Components/ThematicIcon/ThematicIcon';
import { isMobile } from 'Helpers/devices';
import StaticMapWrapper from 'Components/StaticMap/StaticMapWrapper';
import { FormattedMessage as Translation } from 'react-intl';
import { getGoogleMapsDestinationURL } from 'Constants/googleMaps';
import withConfig from 'HOCs/withConfig/withConfig';

export const LocationDetails = ({
    address,
    latitude,
    longitude,
    showDirectionsCTA,
    config,
    iconColor = 'primary',
    overrideClass
}) => {
    const language = config.get('lang');

    return (
        <div className={ overrideClass?.locationDetails || css.locationDetails } >
            <div className={ css.icon }>
                <Icon icon="location" size={ isMobile ? 16 : 36 } color={ iconColor } />
            </div>
            {address && latitude && longitude
                && <div className={ css.addressBox }>
                    {address && <div>{address}</div>}
                    { showDirectionsCTA && latitude && longitude
                        && <a
                            className={ css.directionsLink }
                            rel="noopener noreferrer"
                            target="_blank"
                            href={ getGoogleMapsDestinationURL(latitude, longitude) }
                        ><Translation id="getDirections" /></a>
                    }
                </div>
            }
            { latitude && longitude
                && <div className={ overrideClass?.mapImage || css.mapImage }>
                    <a
                        rel="noopener noreferrer"
                        target="_blank"
                        href={ getGoogleMapsDestinationURL(latitude, longitude) }
                    >
                        <StaticMapWrapper
                            latitude={ latitude }
                            longitude={ longitude }
                            size={ '640x410' }
                            language={ language }
                            circleClassName={ css.googleMapCircle }
                            isStaticUrl
                        />
                    </a>
                </div>
            }
        </div>
    );
};

LocationDetails.propTypes = {
    address: PropTypes.string,
    latitude: PropTypes.string,
    longitude: PropTypes.string,
    showDirectionsCTA: PropTypes.bool,
    config: PropTypes.object,
    iconColor: PropTypes.string,
    overrideClass: PropTypes.object
};

LocationDetails.defaultProps = {
    address: '',
    latitude: '',
    longitude: '',
    showDirectionsCTA: false,
    config: {}
};

export default withConfig(React.memo(LocationDetails));
